<template>
  <img alt="logo" src="../assets/mainLogo.png" height="350" style="padding-top: 10px;">
  <div class="center">
    <p v-bind:class="{ isred: nameError }"> Enter your license number to view the leaderboard </p>

    <div class="container">
      <template v-if="error != ''">
        <div class="row">
          <p>{{ error }}</p>
        </div>
      </template>
      <div class="row">
        <input class="input" placeholder="License Number" v-model="license" />
      </div>

      <div class="row">
        <button class="button" type="submit" @click="GameSetup()">Go</button>
      </div>
    </div>
  </div>
</template>

<style>
@import '../assets/form.css';
</style>

<script>
import { callApi } from '../plugins/callApi.js'
export default {
  name: 'setupGame',
  props: {

  },
  data() {
    return {
      teamName: "",
      nameError: false,
      license: "",
      boxid: "",
      error: "",


    }
  },
  async mounted() {


    if (localStorage.getItem("leaderBoardLicense") !== null) {
      this.license = localStorage.getItem("leaderBoardLicense")
      // this.GameSetup()
    }
  },
  methods: {
    async GameSetup() {

      if (this.license == '') {
        this.error = "Please enter a license"
      } else {
         this.$parent.gameData = await callApi("leaderboard",  this.license )
        localStorage.setItem('leaderBoardLicense', this.license);
     //   console.log(await axios.post('https://bthapi.xcapismlearning.com/leaderboard', { "license": this.license }))
    //    this.$parent.gameData = (await axios.post('https://bthapi.xcapismlearning.com/leaderboard', { "license": this.license })).data.body
        this.$emit('setup', true)
        this.$parent.setup = true

      }
    }
  }
}
</script>


